/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable indent */
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-hook-form';
import { Button } from 'primereact/button';
import { useQuery, useMutation } from 'react-query';
import { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { NumberInput, TextInput, Tickbox } from 'components/FormControl';
import { getProjectById } from 'apis/projects.api';
import { createRegisterResult } from 'apis/registerResult.api';
import Loading from 'components/Loading';
import { toast } from 'layout';
import { TOAST } from 'constant';
import GeneralInfoCheckResult from 'features/SubmitProjectProposal/components/GeneralInfoCheckResult';

function CreateCheckResult() {
  const { t } = useTranslation();
  const { projectId } = useParams();
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
  } = useForm();

  const navigate = useNavigate();

  const { isDirty, dirtyFields } = useFormState({ control });

  // #region Data

  const B1Options = Array.from({ length: 13 }, (_, index) => index + 1);
  const B2Options = Array.from({ length: 4 }, (_, index) => index + 1);
  const B3Options = [
    { id: 1, quantity: 4, sub: Array.from({ length: 4 }, (_, index) => index + 1) },
    { id: 2, quantity: 3, sub: Array.from({ length: 3 }, (_, index) => index + 1) },
    { id: 3, quantity: 4, sub: Array.from({ length: 4 }, (_, index) => index + 1) },
    { id: 4, quantity: 2, sub: Array.from({ length: 2 }, (_, index) => index + 1) },
    { id: 5, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 6, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 7, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 8, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 9, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 10, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 11, quantity: 1, sub: Array.from({ length: 1 }, (_, index) => index + 1) },
    { id: 12, quantity: 2, sub: Array.from({ length: 2 }, (_, index) => index + 1) },
  ];

  const { data: _data, isLoading: isProjectDataLoading } = useQuery({
    queryKey: ['projectData', projectId],
    queryFn: () => getProjectById(projectId),
  });

  const projectData = useMemo(() => _data?.data ?? [], [_data]);

  const owner = useMemo(
    () =>
      projectData?.projectProposal?.projectProposalContacts?.filter(
        (ppContact) => ppContact.projectRole.code === 'OWNER' ?? null
      ),
    [projectData]
  );

  const { mutate: createMutate } = useMutation(createRegisterResult);

  // #endregion

  // #region Envent
  const handleCheck = (name) => {
    const [token, key, order, subOrder] = name.split('.');
    let otherKeys = [];
    switch (key) {
      case 'qualified':
        otherKeys = ['notQualified'];
        break;
      case 'notQualified':
        otherKeys = ['qualified'];
        break;
      default:
        break;
    }
    if (subOrder) {
      setValue(`${token}.${otherKeys}.${order}.${subOrder}`, false);
    } else if (order) {
      setValue(`${token}.${otherKeys}.${order}`, false);
    } else {
      setValue(`${token}.${otherKeys}`, false);
    }
  };

  const handleQualified = (qualified, notQualified) => {
    if (qualified === true) {
      return 'qualified';
    }
    if (notQualified === true) {
      return 'notQualified';
    }
    return 'notReviewed';
  };

  const onSubmit = (data) => {
    const B1Sender = {
      cd: {},
      registerResultForm: {},
      settlementConfirmation: {},
      acceptanceConclusion: {},
      acceptanceReport: {},
      acceptanceReview: {},
      liquidationReport: {},
      settlementOrganization: {},
      renewalForm: {},
      personnelAdjustment: {},
      expenditureApproved: {},
      contract: {},
      outlineExplanation: {},
    };
    let index = 1;
    for (const key in B1Sender) {
      B1Sender[key] = {
        owner: data.B1.owner[index] === true,
        conclusion: handleQualified(data.B1.qualified[index], data.B1.notQualified[index]),
        review: data.B1.review[index],
      };
      index += 1;
    }
    const B2Sender = {
      summaryReport: {},
      formR08: {
        summary: {},
        ownerSignature: {},
        chairmanSignature: {},
        organization: {},
      },
    };
    for (const key in B2Sender) {
      if (key === 'summaryReport') {
        B2Sender[key] = {
          owner: data.B2.owner[14] === true,
          conclusion: handleQualified(data.B2.qualified[14], data.B2.notQualified[14]),
          review: data.B2.review[14],
        };
      } else {
        index = 1;
        for (const subKey in B2Sender[key]) {
          B2Sender[key][subKey] = {
            owner: data.B2.owner[index] === true,
            conclusion: handleQualified(data.B2.qualified[index], data.B2.notQualified[index]),
            review: data.B2.review[index],
          };
          index += 1;
        }
      }
    }
    const B3Sender = {
      k1: {
        internationalJournalQ1: {},
        internationalBook: {},
        internationalConferenceA: {},
        abs4abcdA: {},
      },
      k2: {
        internationalJournalQ2: {},
        internationalConferenceB: {},
        abs3: {},
        domesticJournalA: {},
      },
      k3: {
        internationalJournalQ3Q4: {},
        domesticBook: {},
        internationalConferenceC: {},
        abs21abcdBC: {},
      },
      k4: {
        journalConferenceScopus: {},
        foreignBook: {},
      },
      k5: {},
      k6: {},
      k7: {},
      k8: {},
      k9: {},
      k10: {},
      k11: {},
      k12: {
        postgraduateTraining: {},
        postgraduateTopic: {},
      },
    };
    index = 1;
    for (const key in B3Sender) {
      if (
        key === 'k5' ||
        key === 'k6' ||
        key === 'k7' ||
        key === 'k8' ||
        key === 'k9' ||
        key === 'k10' ||
        key === 'k11'
      ) {
        B3Sender[key] = {
          registeredQuantity: data.B3.registerQuantity[index][1] ?? 0,
          achievedQuantity: data.B3.reachedQuantity[index][1] ?? 0,
          owner: data.B3.owner[index][1] === true,
          conclusion: handleQualified(data.B3.qualified[index][1], data.B3.notQualified[index][1]),
          review: data.B3.review[index][1],
        };
      } else {
        let subIndex = 1;
        for (const subKey in B3Sender[key]) {
          B3Sender[key][subKey] = {
            registeredQuantity: data.B3.registerQuantity[index][subIndex] ?? 0,
            achievedQuantity: data.B3.reachedQuantity[index][subIndex] ?? 0,
            owner: data.B3.owner[index][subIndex] === true,
            conclusion: handleQualified(
              data.B3.qualified[index][subIndex],
              data.B3.notQualified[index][subIndex]
            ),
            review: data.B3.review[index][subIndex],
          };
          subIndex += 1;
        }
      }
      index += 1;
    }
    const dataSender = {
      ...B1Sender,
      ...B2Sender,
      ...B3Sender,
      presidingAgencyConclusion: handleQualified(data.C1.qualified, data.C1.notQualified),
      managingAgencyConclusion: handleQualified(data.C2.qualified, data.C2.notQualified),
      projectId,
    };
    createMutate(dataSender, {
      onSuccess: () => {
        toast(TOAST.SUCCESS, t('checkResult.action.createSuccess'));
        navigate(`/projects-submit/check-result/edit/${projectId}`);
      },
      onError: (err) => {
        toast(TOAST.ERROR, err?.response?.data?.message);
      },
    });
  };

  // #endregion

  // #region Render

  // #endregion

  return (
    <>
      {isProjectDataLoading && <Loading />}
      <div className="m-0 bg-white p-5 p-fluid detail-info-project-proposal">
        <div className="mb-5 flex justify-content-between align-items-center">
          <img
            src={`${process.env.PUBLIC_URL}/logo.png`}
            alt="VNU-HCM logo"
            height="75px"
            className="ml-3"
          />
          <div className="text-right mr-4">
            <p className="m-0">{t('checkResult.proposalCode')}</p>
            <p>{t('checkResult.dateCheckDocument')}</p>
          </div>
        </div>
        <h3 className="mb-5 line-height-3 text-4xl text-center font-bold">
          {t('checkResult.title')}
          <br />
          <span className="font-normal">{t('checkResult.subTitle')}</span>
        </h3>
        <div className="ml-4">
          <div className="pb-2">
            <h4>A. {t('checkResult.A.title')}</h4>
            <GeneralInfoCheckResult
              owner={owner?.[0]}
              generalInfoData={projectData?.projectProposal}
            />

            {/* part B */}
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="false">
              <h4>B. {t('checkResult.B')}</h4>
              <h4>B1. {t('checkResult.B1.title')}</h4>
              <div
                className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines"
                data-scrollselectors=".p-datatable-wrapper"
              >
                <div className="p-datatable-wrapper">
                  <table className="p-datatable-table form-table">
                    <thead>
                      <tr>
                        <th rowSpan="2">{t('checkResult.table.checkContent')}</th>
                        <th rowSpan="2">{t('checkResult.table.owner')}</th>
                        <th rowSpan="1" colSpan="2">
                          {t('checkResult.table.conclude')}
                        </th>
                        <th rowSpan="2" style={{ width: '30rem', minWidth: '18rem' }}>
                          {t('checkResult.table.opinion')}
                        </th>
                      </tr>
                      <tr>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.qualified')}
                        </th>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.notQualified')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {B1Options.map((item) => (
                        <tr>
                          <td>
                            {item}. {t(`checkResult.B1.${item}`)}
                          </td>
                          <td className="text-center">
                            <Tickbox control={control} errors={errors} name={`B1.owner.${item}`} />
                          </td>
                          <td className="text-center">
                            <Tickbox
                              control={control}
                              errors={errors}
                              name={`B1.qualified.${item}`}
                              onCustomCheck={handleCheck}
                            />
                          </td>
                          <td className="text-center">
                            <Tickbox
                              control={control}
                              errors={errors}
                              name={`B1.notQualified.${item}`}
                              onCustomCheck={handleCheck}
                            />
                          </td>
                          <td>
                            <TextInput
                              control={control}
                              errors={errors}
                              name={`B1.review.${item}`}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <h4 className="mt-4">B2. {t('checkResult.B2.title')}</h4>
              <div
                className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines"
                data-scrollselectors=".p-datatable-wrapper"
              >
                <div className="p-datatable-wrapper">
                  <table className="p-datatable-table form-table">
                    <thead>
                      <tr>
                        <th rowSpan="2">{t('checkResult.table.checkContent')}</th>
                        <th rowSpan="2">{t('checkResult.table.owner')}</th>
                        <th rowSpan="1" colSpan="2">
                          {t('checkResult.table.conclude')}
                        </th>
                        <th rowSpan="2" style={{ width: '30rem', minWidth: '18rem' }}>
                          {t('checkResult.table.opinion')}
                        </th>
                      </tr>
                      <tr>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.qualified')}
                        </th>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.notQualified')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>14. {t('checkResult.B2.14')}</td>
                        <td className="text-center">
                          <Tickbox control={control} errors={errors} name="B2.owner.14" />
                        </td>
                        <td className="text-center">
                          <Tickbox
                            control={control}
                            errors={errors}
                            name="B2.qualified.14"
                            onCustomCheck={handleCheck}
                          />
                        </td>
                        <td className="text-center">
                          <Tickbox
                            control={control}
                            errors={errors}
                            name="B2.notQualified.14"
                            onCustomCheck={handleCheck}
                          />
                        </td>
                        <td>
                          <TextInput control={control} errors={errors} name="B2.review.14" />
                        </td>
                      </tr>
                      <tr>
                        <td>15. {t('checkResult.B2.15.title')}</td>
                        <td />
                        <td />
                        <td />
                        <td />
                      </tr>
                      {B2Options.map((item) => (
                        <tr>
                          <td>
                            {item === 1 && t('checkResult.B2.15.summary')}
                            {item === 2 && t('checkResult.B2.15.ownerSignature')}
                            {item === 3 && t('checkResult.B2.15.presidentCouncilSignature')}
                            {item === 4 && t('checkResult.B2.15.presidingAgencySignature')}
                          </td>
                          <td className="text-center">
                            <Tickbox control={control} errors={errors} name={`B2.owner.${item}`} />
                          </td>
                          <td className="text-center">
                            <Tickbox
                              control={control}
                              errors={errors}
                              name={`B2.qualified.${item}`}
                              onCustomCheck={handleCheck}
                            />
                          </td>
                          <td className="text-center">
                            <Tickbox
                              control={control}
                              errors={errors}
                              name={`B2.notQualified.${item}`}
                              onCustomCheck={handleCheck}
                            />
                          </td>
                          <td>
                            <TextInput
                              control={control}
                              errors={errors}
                              name={`B2.review.${item}`}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <h4 className="mt-4">B3. {t('checkResult.B3.title')}</h4>
              <div
                className="p-datatable p-component p-datatable-responsive-scroll p-datatable-gridlines"
                data-scrollselectors=".p-datatable-wrapper"
              >
                <div className="p-datatable-wrapper">
                  <table className="p-datatable-table form-table">
                    <thead>
                      <tr>
                        <th rowSpan="2">{t('checkResult.table.checkContent')}</th>
                        <th rowSpan="2" style={{ width: '6rem', minWidth: '4rem' }}>
                          {t('checkResult.table.registerQuantity')}
                        </th>
                        <th rowSpan="2" style={{ width: '6rem', minWidth: '4rem' }}>
                          {t('checkResult.table.reachedQuantity')}
                        </th>
                        <th rowSpan="2">{t('checkResult.table.owner')}</th>
                        <th rowSpan="1" colSpan="2">
                          {t('checkResult.table.conclude')}
                        </th>
                        <th rowSpan="2" style={{ width: '30rem', minWidth: '18rem' }}>
                          {t('checkResult.table.opinion')}
                        </th>
                      </tr>
                      <tr>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.qualified')}
                        </th>
                        <th style={{ width: '6rem', minWidth: '3rem' }}>
                          {t('checkResult.table.notQualified')}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {B3Options.map((item) => (
                        <>
                          <tr>
                            <td>
                              {item.id}. {t(`checkResult.B3.${item.id}.title`)}
                            </td>
                            <td />
                            <td />
                            <td />
                            <td />
                            <td />
                          </tr>
                          {item.sub.map((subItem) => (
                            <tr>
                              <td>{t(`checkResult.B3.${item.id}.${subItem}`)}</td>
                              <td className="text-center">
                                <NumberInput
                                  control={control}
                                  errors={errors}
                                  name={`B3.registerQuantity.${item.id}.${subItem}`}
                                />
                              </td>
                              <td className="text-center">
                                <NumberInput
                                  control={control}
                                  errors={errors}
                                  name={`B3.reachedQuantity.${item.id}.${subItem}`}
                                />
                              </td>
                              <td className="text-center">
                                <Tickbox
                                  control={control}
                                  errors={errors}
                                  name={`B3.owner.${item.id}.${subItem}`}
                                />
                              </td>
                              <td className="text-center">
                                <Tickbox
                                  control={control}
                                  errors={errors}
                                  name={`B3.qualified.${item.id}.${subItem}`}
                                  onCustomCheck={handleCheck}
                                />
                              </td>
                              <td className="text-center">
                                <Tickbox
                                  control={control}
                                  errors={errors}
                                  name={`B3.notQualified.${item.id}.${subItem}`}
                                  onCustomCheck={handleCheck}
                                />
                              </td>
                              <td>
                                <TextInput
                                  control={control}
                                  errors={errors}
                                  name={`B3.review.${item.id}.${subItem}`}
                                />
                              </td>
                            </tr>
                          ))}
                        </>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              {/* part C */}
              <h4 className="mt-4">C. {t('checkResult.C.title')}</h4>
              <div className="mb-8">
                <h4>C1. {t('checkResult.C.C1.title')}</h4>
                <div className="flex gap-2">
                  <Tickbox
                    control={control}
                    errors={errors}
                    name="C1.qualified"
                    onCustomCheck={handleCheck}
                  />
                  <span className="mt-1">{t('checkResult.C.C1.qualified')}</span>
                </div>
                <div className="flex gap-2 mt-1">
                  <Tickbox
                    control={control}
                    errors={errors}
                    name="C1.notQualified"
                    onCustomCheck={handleCheck}
                  />
                  <span className="mt-1">{t('checkResult.C.C1.notQualified')}</span>
                </div>
                <div className="flex justify-content-around">
                  <h4>{t('checkResult.signature.owner')}</h4>
                  <h4>{t('checkResult.signature.specialist')}</h4>
                  <h4>{t('checkResult.signature.head')}</h4>
                </div>
              </div>

              <div className="mb-8">
                <h4>C2. {t('checkResult.C.C2.title')}</h4>
                <div className="flex gap-2">
                  <Tickbox
                    control={control}
                    errors={errors}
                    name="C2.qualified"
                    onCustomCheck={handleCheck}
                  />
                  <span className="mt-1">{t('checkResult.C.C2.qualified')}</span>
                </div>
                <div className="flex gap-2 mt-1">
                  <Tickbox
                    control={control}
                    errors={errors}
                    name="C2.notQualified"
                    onCustomCheck={handleCheck}
                  />
                  <span className="mt-1">{t('checkResult.C.C2.notQualified')}</span>
                </div>
                <div className="flex justify-content-around">
                  <h4>{t('checkResult.signature.specialist')}</h4>
                  <h4>{t('checkResult.signature.head')}</h4>
                </div>
              </div>
              <div className="flex justify-content-end gap-2 mr-8">
                <Button
                  label={t('formLayout.save')}
                  className="w-7rem"
                  type="submit"
                  severity="info"
                  disabled={!(isDirty && Object.keys(dirtyFields).length > 0)}
                />
                <Button
                  label={t('formLayout.submit')}
                  className="w-7rem"
                  type="submit"
                  severity="success"
                  disabled
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreateCheckResult;
